import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=75117f50&scoped=true"
import script from "./StudentDetail.vue?vue&type=script&lang=js"
export * from "./StudentDetail.vue?vue&type=script&lang=js"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=75117f50&prod&scoped=true&lang=less"
import style1 from "./StudentDetail.vue?vue&type=style&index=1&id=75117f50&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75117f50",
  null
  
)

export default component.exports